import { IconButton } from "@mui/material"
import { BiCog } from "react-icons/bi"

export const ColumnConfigButton = (props: { onClick: () => void }) => (
	<IconButton
		aria-label={"カラム設定"}
		size="small"
		onClick={props.onClick}
		sx={{
			position: "absolute",
			right: "0px",
			top: "50%",
			transform: "translateY(-50%)",
			fontWeight: "normal",
			color: "grey.400",
		}}
	>
		<BiCog />
	</IconButton>
)
